import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const http = httpFactory({ baseURL: configurationURL.accounts.baseUrl });

export const getSsoSettings = () => http.get(`/google_sso`).then(resp => resp.data);

export const createSsoSettings = data => http.post(`/google_sso`, data).then(resp => resp.data);

export const updateSsoSettings = data => http.patch(`/google_sso`, data).then(resp => resp.data);

export const parseGoogleIdp = (data: File) => {
  const formData = new FormData();
  formData.append('file', data);

  return http.post(`/google_idp_parser`, formData).then(resp => resp.data);
};
